import {
  discoverEip6963Providers,
  ensureResolvedInjectedProvider,
  installBraveProxyErrorGuard,
} from './utils/injectedEthereum'

discoverEip6963Providers()
installBraveProxyErrorGuard()
ensureResolvedInjectedProvider()